module.exports = __webpack_public_path__ + "static/media/BG.ca5758eb.png";